export const RESOURCE_TYPES = ["All", "Guide", "Checklist", "Template", "Article", "Webinar"];

export const RESOURCES = [
  {
    title: "IT Risk & Readiness Scorecard",
    type: "Checklist",
    topic: "Technology Strategy",
    summary:
      "A quick self-assessment to gauge your technology risk, readiness, and the areas most worth attention.",
    gated: true,
    slug: "it-risk-readiness-scorecard",
    icon: "ClipboardCheck",
  },
  {
    title: "Cybersecurity Readiness Checklist",
    type: "Checklist",
    topic: "Cybersecurity",
    summary:
      "A practical checklist to evaluate where your business stands on security fundamentals — without the fear.",
    gated: true,
    slug: "cybersecurity-readiness-checklist",
    icon: "ShieldCheck",
  },
  {
    title: "Technology Roadmap Template",
    type: "Template",
    topic: "Technology Strategy",
    summary:
      "A simple, reusable template to sequence your technology priorities into a clear 12–36 month plan.",
    gated: true,
    icon: "Map",
  },
  {
    title: "Legacy System Modernization Planner",
    type: "Template",
    topic: "Modernization",
    summary:
      "A structured planner to evaluate aging systems and weigh the risk of staying versus modernizing.",
    gated: true,
    slug: "legacy-system-modernization-planner",
    icon: "RefreshCw",
  },
  {
    title: "Vendor Selection Checklist",
    type: "Checklist",
    topic: "Vendor Selection",
    summary:
      "Define requirements, compare vendors objectively, and choose the right fit instead of the best pitch.",
    gated: true,
    slug: "vendor-selection-checklist",
    icon: "Search",
  },
  {
    title: "AI Readiness Checklist",
    type: "Checklist",
    topic: "Artificial Intelligence",
    summary:
      "Assess whether your data, processes, and governance are ready for practical, responsible AI adoption.",
    gated: true,
    slug: "ai-readiness-checklist",
    icon: "Sparkles",
  },
  {
    title: "Business Process Improvement Worksheet",
    type: "Template",
    topic: "Operations",
    summary:
      "Map a workflow, spot the friction, and identify the highest-value opportunities to improve or automate.",
    gated: true,
    slug: "business-process-improvement-worksheet",
    icon: "Cog",
  },
  {
    title: "How to Create a Practical Technology Roadmap",
    type: "Article",
    topic: "Technology Strategy",
    summary:
      "A step-by-step guide to building a roadmap that ties technology decisions to real business goals.",
    gated: false,
    slug: "practical-technology-roadmap",
    icon: "Map",
  },
  {
    title: "How to Evaluate Legacy Software Before Replacing It",
    type: "Article",
    topic: "Modernization",
    summary:
      "Before you rip and replace, run this honest evaluation of fit, risk, and the cost of staying put.",
    gated: false,
    slug: "evaluate-legacy-software",
    icon: "RefreshCw",
  },
  {
    title: "How to Decide Whether Your Business Needs a Fractional CTO",
    type: "Article",
    topic: "Executive Leadership",
    summary:
      "The signs that point to a fractional technology leader — and when a full-time hire makes more sense.",
    gated: false,
    slug: "do-you-need-a-fractional-cto",
    icon: "UserCog",
  },
  {
    title: "What to Do When Your Business Systems Don't Communicate",
    type: "Article",
    topic: "Systems Integration",
    summary:
      "Disconnected systems quietly cap your growth. Here's how to diagnose the issue and fix it deliberately.",
    gated: false,
    slug: "systems-that-dont-communicate",
    icon: "Network",
  },
  {
    title: "Reducing Technology Risk Before a Major Project (Webinar)",
    type: "Webinar",
    topic: "Project Leadership",
    summary:
      "An on-demand session on de-risking big initiatives with structure, scope clarity, and accountability.",
    gated: false,
    webinar: true,
    icon: "Video",
  },
];

// ---------- Insights / Blog (genuine educational articles, no invented proof) ----------
